import { render, staticRenderFns } from "./loucengpicker.vue?vue&type=template&id=5c025214&scoped=true&"
import script from "./loucengpicker.vue?vue&type=script&lang=js&"
export * from "./loucengpicker.vue?vue&type=script&lang=js&"
import style0 from "./loucengpicker.vue?vue&type=style&index=0&id=5c025214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c025214",
  null
  
)

export default component.exports